var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1541,
    y: -1109,
    width: 8201,
    height: 3991,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6461_10872)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-1160 -580)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1160,
    y: -580,
    width: 1920,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8955 6.40625C14.1415 6.40713 13.3937 6.5428 12.6875 6.80685L20.8859 15.0052C21.1534 14.2902 21.2891 13.5327 21.2865 12.7693C21.2791 11.0791 20.6025 9.46074 19.4047 8.26824C18.207 7.07573 16.5856 6.40623 14.8955 6.40625Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7295 12.3319C26.5899 6.52788 21.084 3.01562 14.9911 3.01562C13.3322 3.01952 11.6845 3.28681 10.1094 3.80751L11.6093 5.31676C12.7141 5.03124 13.8501 4.88415 14.9911 4.87889C20.2362 4.87889 25.0062 7.80421 27.8476 12.7325C26.8053 14.561 25.4235 16.1736 23.7764 17.4839L25.0993 18.8068C27.0055 17.269 28.5886 15.3692 29.7575 13.217L29.9997 12.7698L29.7295 12.3319Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31976 1.38813L6.47484 5.54321C3.8485 7.23422 1.702 9.57323 0.242224 12.3348L0 12.7727L0.242224 13.2199C3.38182 19.0239 8.88776 22.5362 14.9806 22.5362C17.3588 22.5357 19.706 21.9974 21.8468 20.9617L26.5049 25.6199L28.1353 24.2224L3.91285 0L2.31976 1.38813ZM10.0523 9.12068C9.1807 10.3499 8.77217 11.8478 8.89905 13.3493C9.02593 14.8508 9.68003 16.259 10.7455 17.3245C11.811 18.39 13.2192 19.0441 14.7207 19.171C16.2222 19.2979 17.7202 18.8894 18.9494 18.0178L20.44 19.5084C18.7144 20.246 16.8573 20.6263 14.9806 20.6263C9.73555 20.6263 4.9656 17.701 2.12412 12.7727C3.48776 10.3581 5.45165 8.33643 7.82571 6.90339L10.0523 9.12068Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6461_10872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-1160 -580)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.97cd4733ed8d71a4afb5e1679fe39bf6.svg";
export { ForwardRef as ReactComponent };